var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg",style:({ filter: 'blur(' + _vm.blur + ')', backgroundImage: 'url(' + _vm.bgImage + ')' })})}
var staticRenderFns = []

export { render, staticRenderFns }